module.exports = __webpack_public_path__ + "media/images/salles de conférence-d436f10edbe18be405d4eed87655adc0.svg";